import React from 'react';

import { ErrorPageSVG } from 'assets/img';
import { TextView } from 'components';
import ButtonViewV3 from 'components/ButtonViewV3/ButtonViewV3';
import UserInfo from 'templates/UserInfo';

const ErrorScreen: React.FC = () => {
  return (
    <div
      className="w-full h-full flex items-center justify-center"
      style={{ marginTop: '12%' }}
    >
      <UserInfo
        imageUrl={ErrorPageSVG}
        headingText={`We Messed up`}
        subText={[]}
        buttonComponent={
          <div className="flex flex-col justify-center items-center ">
            <TextView
              text={`Looks like there was an issue loading the templates.`}
              color="#667085"
            />
            <TextView
              text={` Try refreshing your browser and reach out to`}
              color="#667085"
            />
            <TextView
              text={`customer support if the problem persists`}
              color="#667085"
            />
            <div className="mt-9">
              <ButtonViewV3
                size="m"
                label="Refresh Page"
                variant="tertiary"
                onClick={() => window.location.reload()}
              />
            </div>
          </div>
        }
      />
    </div>
  );
};

export default ErrorScreen;
